import React, { useState } from 'react';
import PropTypes from 'prop-types';
// import { getTalkDetails } from '../utils/services';
import TALKS from '../mocks/talks.json';
import SPEAKERS from '../mocks/speakers.json';

const { Consumer, Provider } = React.createContext();

const TalkDetailsProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [speakers, setSpeakers] = useState([]);
  const [talks, setTalks] = useState([]);

  const loadTalkDetails = async () => {
    setIsLoading(true);
    try {
      // const details = await getTalkDetails(talkId);
      setSpeakers(SPEAKERS);
      setTalks(TALKS);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Provider
      value={{
        isLoading,
        speakers,
        talks,
        loadTalkDetails
      }}>
      {children}
    </Provider>
  );
};

TalkDetailsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export { TalkDetailsProvider, Consumer as TalkDetailsConsumer };
